import autocomplete from 'assets/themes/vacances-campings/js/module/searchForm/autocomplete'
import calendar from 'assets/themes/vacances-campings/js/module/searchForm/calendar'
import events from 'assets/themes/vacances-campings/js/module/searchForm/events'
import maxDistance from 'assets/themes/vacances-campings/js/module/searchForm/maxDistance'
import menus from 'assets/themes/vacances-campings/js/module/searchForm/menus'

export default function (): void {
  calendar()
  autocomplete()
  events()
  menus()
  maxDistance()
}
